export default __webpack_public_path__ + "static/media/cert1.e67df779.jpeg";